import React from "react";

const ShimmerUI = () => {
  return (
    <div className=" w-48 pr-4 hover:scale-110 duration-500 transition transform"></div>
  );
};

export default ShimmerUI;
